import {Locales} from '@netx/core-next/locales/utils/Locales';
import {SearchSortOrder} from '@netx/core-search-rules';
import {SearchContext} from './constants';

export const SearchContextLabel = Locales((i18n) => ({
	[SearchContext.ADVANCED]: i18n('i18n.advancedSearch'),
	[SearchContext.ATTRIBUTE_HISTORY]: i18n('i18n.attributeHistory'),
	[SearchContext.KEYWORD]: i18n('i18n.keyword'),
	[SearchContext.VIDEO_CLIP]: i18n('i18n.videoClips'),
	[SearchContext.VISUAL_ASSET]: i18n('i18n.asset'),
	[SearchContext.VISUAL_COLOR]: i18n('i18n.color'),

	[SearchContext.CATEGORY]: i18n('i18n.category'),
	[SearchContext.SAVED_SEARCH]: i18n('i18n.savedSearch'),
	[SearchContext.SAVED_CART]: i18n('i18n.savedCart'),
	[SearchContext.IDENTIFIED_PEOPLE]: i18n('i18n.people'),
}));

export const SearchSubHeaderLabel = Locales((i18n) => ({
	SEARCHING_FOR: i18n('i18n.lookingFor'),
	SEARCH_WITHIN: i18n('i18n.findIn'),
	SUGGESTIONS: i18n('i18n.suggestions'),
}));

export const SearchPlaceholderLabel = Locales((i18n) => ({
	DEFAULT: i18n('i18n.search'),
	COLOR: 'e.g. #000000',
}));

export const SearchActionLabel = Locales((i18n) => ({
	CLEAR: i18n('i18n.clear'),
}));

export const SearchSortLabel = Locales((i18n) => ({
	SORT: i18n('i18n.sort'),
}));

export const SearchSortFieldLabel = Locales((i18n) => ({}));

export const SearchSortOrderLabel = Locales((i18n) => ({
	[SearchSortOrder.ASC]: i18n('i18n.sortAscending'),
	[SearchSortOrder.DESC]: i18n('i18n.sortDescending'),
}));
